<section class="widget-element widget-billing" [class.clickable]="navigateOnClick" [class.loading]="loadingInvoices && loadingPayments">

  @if (loadingInvoices && loadingPayments) {
    <div class="widget-element-loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <div class="widget-element-header widget-billing-header">
    <div class="widget-element-icon custom-icon billing_dollar"></div>
    <h1 class="widget-element-title widget-billing-title">Billing</h1>
  </div>

  <div class="widget-billing-content">

    @if (invoiceDate) {
      <div class="invoice-container">
        <img class="invoice-image" alt="invoice icon" src="/assets/images/img_widget_invoice_std@2x.png" />
        <div class="invoice-detail">
          <h2>Invoice</h2>
          <div class="posted-date">
            posted {{ invoiceDate | date: 'MMM d, y.' }}
          </div>
        </div>
      </div>
    } @else {
      <div class="invoice-container">
        <img class="invoice-image" alt="invoice icon" src="/assets/images/img_widget_invoice_empty@2x.png" />
        <div class="invoice-detail">
          <h2 class="empty">No Invoices.</h2>
        </div>
      </div>
    }

    @if (paymentTransactionDate) {
      <div class="payment-container">
        <h2>Payment</h2>
        <div class="posted-date">
          posted {{ paymentTransactionDate | date: 'MMM d, y.' }}
        </div>
        <div class="payment-value">
          <span>$</span>
          {{ paymentDollars }}
          <span>{{ paymentCents }}</span>
        </div>
      </div>
    } @else {
      <div class="payment-container">
        <h2 class="empty">No Payment Yet.</h2>
        <div class="payment-value"><span>$</span>&nbsp;- - -</div>
      </div>
    }
  </div>

  <div class="widget_cta">
    <a [routerLink]="hyperlink">View Billing</a>
  </div>

</section>
